module.exports = __webpack_public_path__ + "static/assets/43a6763ad48cb10cb050ea08a352ccca.gif";